<script setup lang="ts">
import ChqMenuGroup from '@/components/menu/ChqMenuGroup.vue';
import ChqMenuItem from '@/components/menu/ChqMenuItem.vue';
import { appVm } from '@/main-store';

Object.assign(appVm.sidebarState, {
    reports: {
        metrics: false,
        subsidies: false,
        productivity: false,
        specialReports: false,
    }
});

</script>
<template>
    <h5>
        Reports
    </h5>
    <ChqMenuGroup :menu-group="appVm.sidebarState.reports.metrics" icon="fa-chart-bar" name="Metrics">
        <ChqMenuItem menu-item="/reports/patient-metrics/summary">Patient Metrics - Summary</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/patient-metrics/details">Patient Metrics - Details</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/service-metrics">Service Metrics</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/item-prep">Item Prep</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/volume-metrics">Volume Client Metrics</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/geo">Geographic Metrics</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/executive-director-metrics">Executive Director Metrics</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/partnership-metrics">Partnership Metrics</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/no-shows">No Shows</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/drug-log">Drug Log (Inactive)</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/rabies">Rabies Export</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/donations">Donations</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/death">Death</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/recheck">Recheck</ChqMenuItem>
    </ChqMenuGroup>
    <ChqMenuItem menu-item="/reports/master-report"><i class="fas fa-file-export"></i> Master Report</ChqMenuItem>
    <ChqMenuItem menu-item="/reports/microchip-export"><i class="fas fa-microchip"></i> Microchip Export</ChqMenuItem>
    <ChqMenuGroup :menu-group="appVm.sidebarState.reports.subsidies" icon="fa-donate" name="Subsidies">
        <ChqMenuItem menu-item="/reports/subsidies/summary">Summary</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/subsidies/history">History</ChqMenuItem>
    </ChqMenuGroup>
    <ChqMenuGroup :menu-group="appVm.sidebarState.reports.specialReports" icon="fa-coins" name="Special Reports">
        <ChqMenuItem menu-item="/reports/special-reports/petsmart">PetSmart Charities</ChqMenuItem>
    </ChqMenuGroup>
    <ChqMenuGroup :menu-group="appVm.sidebarState.reports.productivity" icon="fa-chart-line" name="Productivity">
        <ChqMenuItem menu-item="/reports/productivity/appointment-scheduling">Appointment Scheduling</ChqMenuItem>
        <ChqMenuItem menu-item="/reports/productivity/priority-appointments">Priority Appointments</ChqMenuItem>
    </ChqMenuGroup>
    <ChqMenuItem menu-item="/reports/custom-reports"><i class="fas fa-table"></i> Custom Reports</ChqMenuItem>
    <ChqMenuItem v-for="(c, index) in appVm.customReports" :menu-item="`/reports/clinic-custom-report/${c.id}`"
        disable-pin="true" :key="index">
        <i class="fas fa-clipboard"></i> {{ c.name }}
    </ChqMenuItem>
</template>